import { SubmitOrderBasicInformations } from './SubmitOrderBasicInformations';

export class SubmitWithMultiplePayments extends SubmitOrderBasicInformations {
    billingaccounts: Array<BillingAccounts>;
}

export class BillingAccounts {
    amount: number;
    tipportion: number;
    billingmethod: string;
    cardnumber?: string;
    expiryyear?: number;
    expirymonth?: number;
    cvv?: string;
    streetaddress?: string;
    streetaddress2?: string;
    city?: string;
    state?: string;
    zip?: string;
    saveonfile?: boolean;
    billingaccountid?: string;
    billingschemeid?: number;
    billingfields?: Array<SubmitBillingFields>;
    cardlastfour?: string;
    cardtype?: string;
    token?: string;
}

class SubmitBillingFields {
    name: string;
    value: string;
}
